import { BlockType } from '../../types/api/ElementType';
import { Namespace } from '../../translation/namespace';

export const ADDITIONAL_EMAIL_ADDRESS = 'additionalEmailAddress';
export function getAdditionalEmailAddressLabelCount(name: string) {
  return Number(name.split(ADDITIONAL_EMAIL_ADDRESS).pop());
}

export const getTranslationNamespaceByElementType = (elementType: string) => {
  switch (elementType) {
    case BlockType.personextendeddata:
      return Namespace.PersonExtendedData;
    case BlockType.personaffiliation:
      return Namespace.PersonAffiliation;
    case BlockType.personcontactdata:
      return Namespace.PersonContactData;
    case BlockType.personadditionalinformation:
      return Namespace.PersonAdditionalInformation;
    default:
      return '';
  }
};
